import { render, staticRenderFns } from "./AddMemberDialog.vue?vue&type=template&id=3063c7cc&scoped=true"
import script from "./AddMemberDialog.vue?vue&type=script&lang=js"
export * from "./AddMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./AddMemberDialog.vue?vue&type=style&index=0&id=3063c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063c7cc",
  null
  
)

export default component.exports